import { render, staticRenderFns } from "./pheadmaster.vue?vue&type=template&id=4ffe7aef&scoped=true&"
import script from "./pheadmaster.vue?vue&type=script&lang=js&"
export * from "./pheadmaster.vue?vue&type=script&lang=js&"
import style0 from "./pheadmaster.vue?vue&type=style&index=0&id=4ffe7aef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffe7aef",
  null
  
)

export default component.exports